export const cnpjMask = (value: string): string => {
  const alphanumericValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 14);

  return alphanumericValue.replace(
    /([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?([A-Z0-9]{2})?/,
    (_, p1, p2, p3, p4, p5) => {
      let mask = p1;
      if (p2) mask += `.${p2}`;
      if (p3) mask += `.${p3}`;
      if (p4) mask += `/${p4}`;
      if (p5) mask += `-${p5}`;
      return mask;
    }
  );
};
